import { useMemo } from "react";

import { CONTACTS_COLUMNS_CONFIG } from "../constants/columns";
import { useCsvEnrichmentColumnConfig } from "../queries/useCsvEnrichmentColumnConfig";
import type { CsvExportColumnConfig, CsvExportColumnOptions } from "../types/columns";
import { fromDtoToColumnExportOptions } from "../utils/dto";

type HookValue = {
    data: CsvExportColumnOptions | undefined;
    isLoading: boolean;
};

export const useCsvExportColumnOptions = (): HookValue => {
    const query = useCsvEnrichmentColumnConfig();

    const contactsEnrichedColumnConfig = useMemo(() => {
        if (!query.data) {
            return;
        }

        const data: CsvExportColumnConfig = {
            ...query.data,
            contacts: {
                ...query.data.contacts,
                contacts: CONTACTS_COLUMNS_CONFIG,
            },
        };

        return fromDtoToColumnExportOptions(data);
    }, [query.data]);

    return { data: contactsEnrichedColumnConfig, isLoading: query.isLoading };
};
